import BaseModel from '@/shared/models/BaseModel';
import SurveyDossier from './SurveyDossier';
import SurveyFeedback from './SurveyFeedback';
import SurveyResult from './SurveyResult';

export interface SurveyId {__surveyId: number}

export default class Survey extends BaseModel<SurveyId> {
  contactNames: Array<string> = [];
  dossier!: SurveyDossier;
  result: SurveyResult | null = null;
  finalized = false;
  feedback: SurveyFeedback | null = null;
  isExpired = false;
}
